import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const CashTopUp = Loadable({
    loader: () => import('./CashTopUp'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          routesCashTopUpState: state.routesCashTopUpState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          submit,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/cash-top-up'
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <CashTopUp {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
